"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const tools_1 = require("./tools");
const WSElementType = {
    OK: 'ok',
    ERROR: 'error',
    ERROR_TIMEOUT: 'error-timeout',
};
const MethodType = {
    POST: 'POST',
    GET: 'GET',
    PUT: 'PUT',
    HEAD: 'HEAD',
};
const ERROR_COLOR = '\x1b[31m%s\x1b[0m'; // red
const WARNING_COLOR = '\x1b[33m%s\x1b[0m'; // yellow
const INFO_COLOR = '\x1b[36m%s\x1b[0m'; // cyan
const SUCCESS_COLOR = '\x1b[32m%s\x1b[0m'; // green
const DefaultHeaders = {
    timeout: 60000,
};
const getProperColorByStatus = (statusCode) => {
    switch (statusCode) {
        case 200:
            return SUCCESS_COLOR;
        case 300:
            return WARNING_COLOR;
        case 500:
            return ERROR_COLOR;
        default:
            return INFO_COLOR;
    }
};
const pipeLog = ({ endpoint, data, headers, status }) => {
    const color = getProperColorByStatus(status);
    if (typeof window === 'undefined') {
        const urlTail = endpoint.replace(/idPeticion=[^&]*&?/, '');
        console.log(color, `Endpoint: ${urlTail}`);
        if (data) {
            console.log(color, JSON.stringify(data).substring(0, 100));
        }
        console.log(color, JSON.stringify(headers));
    }
};
const stopProcessDependsOnBuildAndEnv = (build, endpoint, data, headers) => {
    const currentEnv = `${process.env.NEXT_PUBLIC_ENV_NAME}`;
    if (currentEnv === 'prod' && build) {
        // para el log del pipeline
        if (typeof window === 'undefined') {
            pipeLog({
                endpoint,
                data,
                headers,
                status: 500,
            });
            process.exit(1);
        }
    }
};
class Request {
    constructor({ method = MethodType.GET, endpoint, headers, dataStringify = true, data, sonda, redirectAsReject = false, throwsError = false, beacon = false, build = false, onError, onTimeout, onSuccess, onRedirect, onFetching, }) {
        /* MAIN */
        this.makeRequest = () => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                // configurar peticion y ejecutarla( TODO config de errores falta)
                const { headers: ownHeaders, timeout, withCredentials, } = this.extractFromHeaders2RootProperties();
                if (!this.beacon) {
                    if (this.sonda) {
                        if (this.onFetching) {
                            this.onFetching();
                        }
                    }
                    this.axiosInstance({
                        method: this.method,
                        url: this.endpoint,
                        headers: ownHeaders,
                        timeout,
                        data: this.data,
                        withCredentials,
                    })
                        .then((response) => {
                        this.responseHandler(response, resolve, reject);
                    })
                        .catch((error) => {
                        stopProcessDependsOnBuildAndEnv(this.build, this.endpoint, this.data, this.headers);
                        this.responseHandler(error, resolve, reject);
                    });
                }
                else if (navigator && navigator.sendBeacon) {
                    navigator.sendBeacon(this.endpoint, JSON.stringify(this.data));
                    const isFrontApp = typeof window !== 'undefined';
                    // si estoy en cliente (window) y estoy en dev obligo al parametro
                    const isShowSondaEnable = isFrontApp && window.location.search.indexOf('showSonda') > -1;
                    if (isShowSondaEnable) {
                        const { ctzId, cdEventName, cdTimeStamp, cdEventType } = this.data;
                        console.table([ctzId, cdEventName, cdTimeStamp, cdEventType], ['idPetición', 'Servicio', 'TimeStamp', 'Tipo']);
                    }
                }
            }).catch((err) => {
                this.timeEnd = new Date(Date.now()).toISOString();
                stopProcessDependsOnBuildAndEnv(this.build, this.endpoint, this.data, this.headers);
                if (this.throwsError) {
                    throw err;
                }
                return new Promise((reject, resolve) => {
                    this.responseHandler(err, resolve, reject);
                });
            });
        });
        this.method = method;
        this.endpoint = endpoint;
        this.data = data;
        this.sonda = sonda;
        this.headers = Object.assign(Object.assign({}, DefaultHeaders), headers);
        this.dataStringify = dataStringify;
        this.redirectAsReject = redirectAsReject;
        this.onError = onError;
        this.build = build;
        this.onTimeout = onTimeout;
        this.onSuccess = onSuccess;
        this.onRedirect = onRedirect;
        this.onFetching = onFetching;
        this.throwsError = throwsError;
        this.beacon = beacon;
        this.axiosInstance = axios_1.default.create();
        if (typeof window !== 'undefined') {
            // MOMENTO DE REQ
            this.reqInt = this.axiosInstance.interceptors.request.use((config) => {
                this.timeStart = new Date(Date.now()).toISOString();
                if (this.sonda && this.sonda.startWS) {
                    this.sonda.startWS({ time: this.timeStart });
                }
                // Do something before request is sent
                return config;
            }, (error) => {
                this.timeStart = new Date(Date.now()).toISOString();
                let statusText = '';
                let status = '';
                ({ errorCode: status, errorDetails: statusText } =
                    (0, tools_1.getErrorInfo)(error));
                if (this.sonda && this.sonda.endWS) {
                    this.sonda.endWS({
                        status: WSElementType.OK,
                        info: {
                            status,
                            statusText,
                        },
                        time: this.timeEnd,
                    });
                }
                // Do something with request error
                return Promise.reject(error);
            });
            // MOMENTO DE RESPONSE
            this.resInt = this.axiosInstance.interceptors.response.use((response) => {
                this.timeEnd = new Date(Date.now()).toISOString();
                if (this.sonda && this.sonda.endWS) {
                    this.sonda.endWS({
                        status: WSElementType.OK,
                        info: {
                            status: response.status,
                            statusText: response.statusText || 'Ok',
                        },
                        time: this.timeEnd,
                    });
                }
                // me desuscribo
                this.axiosInstance.interceptors.request.eject(this.reqInt);
                return response;
            }, (error) => {
                this.timeEnd = new Date(Date.now()).toISOString();
                let statusText = '';
                let status = '';
                ({ errorCode: status, errorDetails: statusText } =
                    (0, tools_1.getErrorInfo)(error));
                /* HAY QUE DEDUCIR SI ES TIMEOUT */
                if (error && error.message) {
                    const errorInfo = JSON.stringify(error.message).toLocaleLowerCase();
                    if (errorInfo.includes('timeout')) {
                        statusText = `Timeout Error${this.headers && this.headers.timeout
                            ? `: ${this.headers.timeout}ms`
                            : ''}`;
                    }
                }
                if (this.sonda && this.sonda.endWS) {
                    this.sonda.endWS({
                        status: WSElementType.OK,
                        info: {
                            status,
                            statusText,
                        },
                        time: this.timeEnd,
                    });
                }
                // me desubscribo
                this.axiosInstance.interceptors.request.eject(this.resInt);
                return Promise.reject(error);
            });
        }
        if (!endpoint) {
            console.error('[Request]: endpoint prop can not be undefined');
        }
    }
    responseHandler(response, resolve, reject) {
        // Analizamos la reponse
        let currentStatus = (response && response.status) || 500;
        if (response &&
            response.request &&
            response.request.host &&
            response.request.host === 'accounts.google.com') {
            currentStatus = 300;
        }
        if (currentStatus >= 200 && currentStatus < 300) {
            if (response) {
                if (this.onSuccess) {
                    resolve(this.onSuccess(response));
                }
                else {
                    resolve(response.data);
                }
            }
        }
        else if (currentStatus >= 300 && currentStatus < 400) {
            if (this.redirectAsReject) {
                reject(response);
            }
            else {
                let finalResponse = response;
                if (this.onRedirect) {
                    finalResponse = this.onRedirect(response);
                }
                resolve(finalResponse);
            }
        }
        else {
            let responseToReturn = response;
            // si no ha habido timeout hago tratamiento genral
            if (this.onError) {
                responseToReturn = this.onError(response);
            }
            // error general
            reject(responseToReturn);
        }
        pipeLog({
            endpoint: this.endpoint,
            data: this.data,
            headers: this.headers,
            status: currentStatus,
        });
    }
    extractFromHeaders2RootProperties() {
        const { headers } = this;
        const res = {
            timeout: null,
            withCredentials: null,
            headers: Object.assign({}, headers),
        };
        if (res.headers.timeout) {
            res.timeout = headers.timeout;
            delete res.headers.timeout;
        }
        if (res.headers.withCredentials) {
            res.withCredentials = headers.withCredentials;
            delete res.headers.withCredentials;
        }
        return res;
    }
}
exports.default = Request;
//# sourceMappingURL=index.js.map